import {
  GOLD_TRANSACTION_ALL,
  GOLD_TRANSACTION_GET,
  GOLD_TRANSACTION_GET_HISTORY,
  GOLD_TRANSACTION_DEL,
  GOLD_TRANSACTION_PUT,
  GOLD_TRANSACTION_POST,
  GOLD_TRANSACTION_LOADING,
  GOLD_TRANSACTION_ERROR,
  GOLD_TRANSACTION_SUMMARY_MONTHLY,
} from '../../actions/types';

const initialState = {
  isLoading: true,
  isCompleted: true,
  history: [],
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case GOLD_TRANSACTION_LOADING:
      return { isLoading: true, isCompleted: true };
    case GOLD_TRANSACTION_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case GOLD_TRANSACTION_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case GOLD_TRANSACTION_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case GOLD_TRANSACTION_GET_HISTORY:
      return {
        ...state,
        history: action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case GOLD_TRANSACTION_SUMMARY_MONTHLY:
      return {
        ...state,
        summary: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case GOLD_TRANSACTION_POST:
      return { isLoading: false, isCompleted: true };
    case GOLD_TRANSACTION_PUT:
      return { isLoading: false, isCompleted: true };
    case GOLD_TRANSACTION_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
